import Vue from 'vue';
import pattern from './pattern';
import notDoubleClick from './notDoubleClick';
import positiveNumber from './positiveNumber';
import inputOnlyInteger from './inputOnlyInteger';
import inputOnlyIntegerAndEng from './inputOnlyIntegerAndEng';

Vue.directive('pattern', pattern);
Vue.directive('not-double-click', notDoubleClick);
Vue.directive('positive-number', positiveNumber);
Vue.directive('input-only-integer', inputOnlyInteger)
Vue.directive('input-only-integer-and-eng', inputOnlyIntegerAndEng)

